import log from 'salvo-lite/log'

class SectionUnderHeader {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._compare = document.querySelectorAll('section')[0] === elem.parentElement
        this._height = elem.getBoundingClientRect().height
        this._headerOffset = document.querySelector(elem.getAttribute('data-header-element')).getBoundingClientRect().height

        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        const { _elem, _compare, _height, _headerOffset } = this

        if (_compare) {
            _elem.style.height = _height + _headerOffset + 'px'
            _elem.style.marginTop = '-' + _headerOffset + 'px'
        }
    }
}

export default SectionUnderHeader



// WEBPACK FOOTER //
// ./src/resources/scripts/components/SectionUnderHeader.js